import React from "react";
import Script from 'react-load-script';
import styles from "./OneGov.module.scss";

const OneGov = props => {
  const myRef = React.createRef();
  const handleScriptLoad = () => {
    /*eslint-disable no-undef*/
    const quickFeedPars = {
      placeholder: "bodyScriptOneGov",
      label: "Was this helpful?",
      environment: process.env.REACT_APP_ENV === 'prod' ? 'production' : process.env.REACT_APP_ENV,
      sourceApplication: "AusNotify"
    };
    console.log("quickFeedPars", quickFeedPars);
    quickFeed.init(quickFeedPars);
  };
  return <div>
    <Script
      url={process.env.REACT_APP_TUTD_URL}
      onLoad={handleScriptLoad}
    />
    <div
      className={styles.oneGovFeedbackClass}
      id="bodyScriptOneGov"
      ref={myRef}
    />
  </div>;
}

export default OneGov;
